import { render } from "./ButtonContainer.vue?vue&type=template&id=071ed132&scoped=true"
import script from "./ButtonContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonContainer.vue?vue&type=script&setup=true&lang=js"

import "./ButtonContainer.vue?vue&type=style&index=0&id=071ed132&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071ed132"],['__file',"src/embedded/components/ButtonContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "071ed132"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('071ed132', __exports__)) {
    api.reload('071ed132', __exports__)
  }
  
  module.hot.accept("./ButtonContainer.vue?vue&type=template&id=071ed132&scoped=true", () => {
    api.rerender('071ed132', render)
  })

}


export default __exports__